import { createAction } from '@ngrx/store';

// splash actions
export const showSplash = createAction('[Layout] ✨ Show splash');
export const hideSplash = createAction('[Layout] ✨ Hide splash');

// bottomBar actions
export const toggleBottomBar = createAction('[Layout] Toggle bottomBar');
export const openBottomBar = createAction('[Layout] Open bottomBar');
export const closeBottomBar = createAction('[Layout] Close bottomBar on route change');
export const tryToggleBottomBar = createAction('[Layout] Try toggle bottomBar');
export const changeInstantToggleBottomBar = createAction('[Layout] Change bottomBar instant toggle');

// settings bar actions
export const toggleFloatingSidebar = createAction('[Settings] Toggle settings bar');
export const closeFloatingSidebar = createAction('[Settings] Close settings bar');

// header actions
export const togglePatientCard = createAction('[Layout] Toggle patient card');
export const closePatientCard = createAction('[Layout] Close patient card');
export const showInfos = createAction('[Layout] Show patient information');
export const showWarnings = createAction('[Layout] Show patient warnings');

// footer actions
export const toggleFooter = createAction('[Layout] Toggle footer visibility');
